import React from 'react';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import PageHeader from '../../../shared/ui/page-header/page-header.jsx';
import LegalContentEditorTab from './legal-content-editor-tab.jsx';
import LegalDocumentsTab from './legal-documents-tab.jsx';

function SystemLegalPageView({
  tabs,
  activeTab,
  setActiveTab,
  documents,
  activeDocumentCount,
  uploadForm,
  uploadErrors,
  setUploadField,
  uploadDocument,
  downloadDocument,
  isDocumentsLoading,
  isContentLoading,
  isSaving,
  isDownloadingUid,
  documentsLoadError,
  contentForms,
  contentErrors,
  setContentField,
  saveContentPage,
  refreshContentPage,
  error,
  success,
}) {
  const activeContentTab = tabs.find((tab) => tab.key === activeTab && tab.key !== 'documents');

  return (
    <div>
      <FloatingAlerts
        info={isSaving ? 'Saving...' : ''}
        error={error}
        success={success}
      />
      <PageHeader title="Legal" subtitle="Manage legal documents and client-facing legal content." />

      <div className="widget-content searchable-container list">
        <ul className="nav nav-tabs mb-3">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.key}>
              <button
                type="button"
                className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>

        {activeTab === 'documents' ? (
          <LegalDocumentsTab
            documents={documents}
            activeDocumentCount={activeDocumentCount}
            uploadForm={uploadForm}
            uploadErrors={uploadErrors}
            setUploadField={setUploadField}
            uploadDocument={uploadDocument}
            downloadDocument={downloadDocument}
            isLoading={isDocumentsLoading}
            isSaving={isSaving}
            isDownloadingUid={isDownloadingUid}
            documentsLoadError={documentsLoadError}
          />
        ) : null}

        {activeContentTab ? (
          <LegalContentEditorTab
            key={activeContentTab.key}
            tabKey={activeContentTab.key}
            label={activeContentTab.label}
            form={contentForms[activeContentTab.key]}
            errors={contentErrors[activeContentTab.key] || {}}
            setContentField={setContentField}
            saveContentPage={saveContentPage}
            refreshContentPage={refreshContentPage}
            isLoading={isContentLoading}
            isSaving={isSaving}
          />
        ) : null}
      </div>
    </div>
  );
}

export default SystemLegalPageView;
